import { navItems, footerNavItems, headerNavItems } from '@/modules/core/nav/store/nav.state';
import type { NavItem } from '@/modules/core/nav/models/NavItem';

export function setNavItems(items: NavItem[]): void {
  navItems.value = items;
}

export function setFooterNavItems(items: NavItem[]): void {
  footerNavItems.value = items;
}

export function setHeaderNavItems(items: NavItem[]): void {
  headerNavItems.value = items;
}
